const utilities = require('utilities');

const VALUE_MISSING = 'VALUE_MISSING';
const TYPE_MISMATCH = 'TYPE_MISMATCH';
const PATTERN_MISMATCH = 'PATTERN_MISMATCH';
const TOO_LONG = 'TOO_LONG';
const TOO_SHORT = 'TOO_SHORT';
const BAD_INPUT = 'BAD_INPUT';
const RANGE_UNDERFLOW = 'RANGE_UNDERFLOW';
const RANGE_OVERFLOW = 'RANGE_OVERFLOW';
const STEP_MISMATCH = 'STEP_MISMATCH';
const EMPTY = 'EMPTY';

const errors = {
	VALUE_MISSING,
	TYPE_MISMATCH,
	PATTERN_MISMATCH,
	TOO_LONG,
	TOO_SHORT,
	BAD_INPUT,
	RANGE_UNDERFLOW,
	RANGE_OVERFLOW,
	EMPTY
};

// Generic errors
// Will need specific directions based on input requirements
const messages = {
	[VALUE_MISSING]: 'This field is required. Please provide a value.',
	[TYPE_MISMATCH]: 'This entry does not match the required type.',
	[PATTERN_MISMATCH]: 'This entry does not match the required format.',
	[TOO_LONG]: 'This entry is too long',
	[TOO_SHORT]: 'This entry is too short',
	[BAD_INPUT]: 'This entry does not match the required type.',
	[RANGE_UNDERFLOW]: 'This value is too small. Please increase it to the minimum.',
	[RANGE_OVERFLOW]: 'This value is too large. Please lower it below the maximum.',
	[STEP_MISMATCH]: 'This value must be in certain increments',
	[EMPTY]: 'Please provide a value.'
};

// <input> pattern props can't handle escaped double quotes
let emailRegExp = new RegExp(utilities.regexp.email);
let emailPatternStr = emailRegExp.source;

const patterns = {
	// Raw example of working pattern
	// email: '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
	email: emailPatternStr,
	text: '^$|.*\\S.*'
};

// Takes a ValidityState object, and the field requirements
// Returns custom error messages
const getMessage = (validity, requirements = {}) => {
	let errorMessages = [];

	if (validity.valueMissing) {
		errorMessages.push(messages.VALUE_MISSING);
	}
	if (validity.typeMismatch) {
		errorMessages.push(messages.TYPE_MISMATCH);
	}
	if (validity.patternMismatch) {
		errorMessages.push(requirements.patternMessage || messages.PATTERN_MISMATCH);
	}
	if (validity.tooLong) {
		errorMessages.push(messages.TOO_LONG);
	}
	if (validity.tooShort) {
		errorMessages.push(messages.TOO_SHORT);
	}
	if (validity.rangeUnderflow) {
		errorMessages.push(messages.VALUE_MISSING);
	}
	if (validity.rangeOverflow) {
		errorMessages.push(messages.VALUE_MISSING);
	}
	if (validity.stepMismatch) {
		errorMessages.push(messages.VALUE_MISSING);
	}
	if (validity.badInput) {
		errorMessages.push(messages.BAD_INPUT);
	}

	return errorMessages.join('\n');
};

module.exports = {
	errors,
	messages,
	patterns,
	getMessage
};
